import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const ForgotPasswordPage = Loadable(lazy(() => import('../pages/auth/ForgotPasswordPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// DASHBOARD: GENERAL
export const HomePage = Loadable(lazy(() => import('../pages/dashboard/HomePage')));
export const ProductDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/ProductDetailPage'))
);
export const PageOne = Loadable(lazy(() => import('../pages/dashboard/PageOne')));
export const ChartPage = Loadable(lazy(() => import('../pages/dashboard/ChartPage')));

export const UnderConstructionPage = Loadable(
  lazy(() => import('../pages/dashboard/UnderConstructionPage'))
);
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

// DASHBOARD: AI
export const AiDashboardPage = Loadable(
  lazy(() => import('../pages/dashboard/AiDashboardPage'))
);
export const SetThresholdPage = Loadable(
  lazy(() => import('../pages/dashboard/SetThresholdPage'))
);

// DASHBOARD: USER
export const UsersListPage = Loadable(lazy(() => import('../pages/dashboard/UsersListPage')));
export const UserRolePage = Loadable(lazy(() => import('../pages/dashboard/UserRolePage')));
export const ChangePasswordPage = Loadable(
  lazy(() => import('../pages/dashboard/ChangePasswordPage'))
);
export const AccessSetPasswordPage = Loadable(
  lazy(() => import('../pages/dashboard/AccessSetPasswordPage'))
);
export const AccessLevelPage = Loadable(lazy(() => import('../pages/dashboard/AccessLevelPage')));

// DASHBOARD: SUPPLIER
export const SupplierIntroductionPage = Loadable(
  lazy(() => import('../pages/dashboard/SupplierIntroductionPage'))
);

// DASHBOARD: BANK MANAGEMENT
export const BankPage = Loadable(lazy(() => import('../pages/dashboard/BankPage')));
export const BankBenefitCompanyPage = Loadable(
  lazy(() => import('../pages/dashboard/BankBenefitCompanyPage'))
);
export const BankBenefitPage = Loadable(lazy(() => import('../pages/dashboard/BankBenefitPage')));
export const CurrentBalanceChartCompanyPage = Loadable(
  lazy(() => import('../pages/dashboard/CurrentBalanceChartCompanyPage'))
);
export const CurrentBalanceChartPage = Loadable(
  lazy(() => import('../pages/dashboard/CurrentBalanceChartPage'))
);
export const AvrageTrendPage = Loadable(lazy(() => import('../pages/dashboard/AvrageTrendPage')));
export const AvragePage = Loadable(lazy(() => import('../pages/dashboard/AvragePage')));
export const LoanTrendPage = Loadable(lazy(() => import('../pages/dashboard/LoanTrendPage')));
export const LoanPage = Loadable(lazy(() => import('../pages/dashboard/LoanPage')));
export const WarrTrendPage = Loadable(lazy(() => import('../pages/dashboard/WarrTrendPage')));
export const WarrPage = Loadable(lazy(() => import('../pages/dashboard/WarrPage')));
export const PersenelTrendPage = Loadable(
  lazy(() => import('../pages/dashboard/PersenelTrendPage'))
);
export const PersenelPage = Loadable(lazy(() => import('../pages/dashboard/PersenelPage')));

export const CompanyPage = Loadable(lazy(() => import('../pages/dashboard/CompanyPage')));
export const HoldingPage = Loadable(lazy(() => import('../pages/dashboard/HoldingPage')));
export const HoldingBasePage = Loadable(lazy(() => import('../pages/dashboard/HoldingBasePage')));

export const WarrFilePage = Loadable(lazy(() => import('../pages/dashboard/WarrFilePage')));
export const DepFilePage = Loadable(lazy(() => import('../pages/dashboard/DepFilePage')));
export const LoanFilePage = Loadable(lazy(() => import('../pages/dashboard/LoanFilePage')));

export const MavadDepFilePage = Loadable(lazy(() => import('../pages/dashboard/MavadDepFilePage')));
export const MahsoolDepFilePage = Loadable(lazy(() => import('../pages/dashboard/MahsoolDepFilePage')));
export const SellMDepFilePage = Loadable(lazy(() => import('../pages/dashboard/SellMDepFilePage')));
export const CIFDepFilePage = Loadable(lazy(() => import('../pages/dashboard/CIFDepFilePage')));
export const TaminDepFilePage = Loadable(lazy(() => import('../pages/dashboard/TaminDepFilePage')));


export const RegMamaPage = Loadable(lazy(() => import('../pages/dashboard/RegMamaPage')));
export const TasvibMamaPage = Loadable(lazy(() => import('../pages/dashboard/TasvibMamaPage')));
export const TahaghoghMamaPage = Loadable(lazy(() => import('../pages/dashboard/TahaghoghMamaPage')));
export const MamaRptPage = Loadable(lazy(() => import('../pages/dashboard/MamaRptPage')));
export const MAMADashPage = Loadable(lazy(() => import('../pages/dashboard/MAMADashPage')));
export const MamaRptEnherafPage = Loadable(lazy(() => import('../pages/dashboard/MamaRptEnherafPage')));


export const AccountTemplatePage = Loadable(lazy(() => import('../pages/dashboard/AccountTemplatePage')));
export const AccountAWCTemplatePage = Loadable(lazy(() => import('../pages/dashboard/AccountAWCTemplatePage')));
export const AccountAWCPage = Loadable(lazy(() => import('../pages/dashboard/AccountAWCPage')));
export const AccountTAWCPage = Loadable(lazy(() => import('../pages/dashboard/AccountTAWCPage')));
export const AccountTRANPage = Loadable(lazy(() => import('../pages/dashboard/AccountTRANPage')));



// DASHBOARD: Data Entry
export const AccountInfoPage = Loadable(lazy(() => import('../pages/dashboard/AccountInfoPage')));
export const AmountInfoPage = Loadable(lazy(() => import('../pages/dashboard/AmountInfoPage')));
export const LoanInfoPage = Loadable(lazy(() => import('../pages/dashboard/LoanInfoPage')));
export const WarrInfoPage = Loadable(lazy(() => import('../pages/dashboard/WarrInfoPage')));
export const ApprovalsInfoPage = Loadable(lazy(() => import('../pages/dashboard/ApprovalsInfoPage')));

// DASHBOARD: SHOPPER
export const BuyerIntroductionPage = Loadable(
  lazy(() => import('../pages/dashboard/BuyerIntroductionPage'))
);

// DASHBOARD: BROKER

// DASHBOARD: GOODS
export const GoodsSearchPage = Loadable(lazy(() => import('../pages/dashboard/GoodsSearchPage')));
export const PRDMPage = Loadable(lazy(() => import('../pages/dashboard/PRDMPage')));
export const LevelPage = Loadable(lazy(() => import('../pages/dashboard/LevelPage')));

// DASHBOARD: WAGE

// DASHBOARD: SUPPLY
export const SetSUPMPage = Loadable(lazy(() => import('../pages/dashboard/SetSUPMPage')));
export const UpdateTRDMPage = Loadable(lazy(() => import('../pages/dashboard/UpdateTRDMPage')));
export const SupplyGroupPage = Loadable(lazy(() => import('../pages/dashboard/SupplyGroupPage')));
export const TRDMDetailPage = Loadable(lazy(() => import('../pages/dashboard/TRDMDetailPage')));

// DASHBOARD: ORDER

// DASHBOARD: ORDERING
export const OrderGeneralListPage = Loadable(
  lazy(() => import('../pages/dashboard/OrderGeneralListPage'))
);
export const OrderListPage = Loadable(lazy(() => import('../pages/dashboard/OrderListPage')));
export const OrderGeneralDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/OrderGeneralDetailPage'))
);
export const OrderDetailPage = Loadable(lazy(() => import('../pages/dashboard/OrderDetailPage')));
export const CheckoutPage = Loadable(lazy(() => import('../pages/dashboard/CheckoutPage')));
export const RegistrationOrderPage = Loadable(
  lazy(() => import('../pages/dashboard/RegistrationOrderPage'))
);

// DASHBOARD: PAYMENT
export const DepositGeneralListPage = Loadable(
  lazy(() => import('../pages/dashboard/DepositGeneralListPage'))
);
export const DepositListPage = Loadable(lazy(() => import('../pages/dashboard/DepositListPage')));
export const DepositConfirmPage = Loadable(
  lazy(() => import('../pages/dashboard/DepositConfirmPage'))
);
export const DepositRegistrationPage = Loadable(
  lazy(() => import('../pages/dashboard/DepositRegistrationPage'))
);
export const DepositAddPage = Loadable(lazy(() => import('../pages/dashboard/DepositAddPage')));

// DASHBOARD: REPORT
export const OnlineAccountBalancePage = Loadable(
  lazy(() => import('../pages/dashboard/OnlineAccountBalancePage'))
);
export const AccountBalancePage = Loadable(
  lazy(() => import('../pages/dashboard/AccountBalancePage'))
);
export const AverageReportPage = Loadable(
  lazy(() => import('../pages/dashboard/AverageReportPage'))
);
export const AccountGeneralListPage = Loadable(
  lazy(() => import('../pages/dashboard/AccountGeneralListPage'))
);
export const AccountListPage = Loadable(lazy(() => import('../pages/dashboard/AccountListPage')));

// DASHBOARD: PRICE
export const SupplyBoardPage = Loadable(lazy(() => import('../pages/dashboard/SupplyBoardPage')));

// DASHBOARD: FINANCIAL
export const CifAccountPage = Loadable(lazy(() => import('../pages/dashboard/CifAccountPage')));
export const DepositManualACCT = Loadable(
  lazy(() => import('../pages/dashboard/DepositManualACCT'))
);

// DASHBOARD: TRANSPORT
export const TransportPage = Loadable(lazy(() => import('../pages/dashboard/TransportPage')));
export const TrafficRptPage = Loadable(lazy(() => import('../pages/dashboard/TrafficRptPage')));
export const TaradodRptPage = Loadable(lazy(() => import('../pages/dashboard/TaradodRptPage')));
export const VehicleListPage = Loadable(lazy(() => import('../pages/dashboard/VehicleListPage')));
export const VehicleCatListPage = Loadable(lazy(() => import('../pages/dashboard/VehicleCatListPage')));
export const VehicleDPage = Loadable(lazy(() => import('../pages/dashboard/VehicleDPage')));

// DASHBOARD: MAVAD
export const MavadGeneralPage = Loadable(lazy(() => import('../pages/dashboard/MavadGeneralPage')));
export const MavadPage = Loadable(lazy(() => import('../pages/dashboard/MavadPage')));
export const MavadReportPage = Loadable(lazy(() => import('../pages/dashboard/MavadReportPage')));
export const MavadDeadStockPage = Loadable(lazy(() => import('../pages/dashboard/MavadDeadStockPage')));

// DASHBOARD: TaminK
export const TaminkReportPage = Loadable(lazy(() => import('../pages/dashboard/TaminkReportPage')));
export const TaminkPage = Loadable(lazy(() => import('../pages/dashboard/TaminkPage')));
export const TaminkAllPage = Loadable(lazy(() => import('../pages/dashboard/TaminkAllPage')));
export const KharidReportPage = Loadable(lazy(() => import('../pages/dashboard/KharidReportPage')));

// DASHBOARD: SellM
export const SellMPage = Loadable(lazy(() => import('../pages/dashboard/SellMPage')));
export const SellAllPage = Loadable(lazy(() => import('../pages/dashboard/SellAllPage')));
export const SellTrendPage = Loadable(lazy(() => import('../pages/dashboard/SellTrendPage')));
export const SellByProductPage = Loadable(lazy(() => import('../pages/dashboard/SellByProductPage')));
export const SellForecastPage = Loadable(lazy(() => import('../pages/dashboard/SellForecastPage')));


// DASHBOARD: CIFM
export const CIFRptPage = Loadable(lazy(() => import('../pages/dashboard/CIFRptPage')));
export const CifAllPage = Loadable(lazy(() => import('../pages/dashboard/CifAllPage')));
export const CifClusterPage = Loadable(lazy(() => import('../pages/dashboard/CifClusterPage')));
export const CifProfilePage = Loadable(lazy(() => import('../pages/dashboard/CifProfilePage')));
export const CallRptPage = Loadable(lazy(() => import('../pages/dashboard/CallRptPage')));

// DASHBOARD: tolid
export const TolidReportPage = Loadable(lazy(() => import('../pages/dashboard/TolidReportPage')));
export const TolidGeneralPage = Loadable(lazy(() => import('../pages/dashboard/TolidGeneralPage')));
export const TolidTrendPage = Loadable(lazy(() => import('../pages/dashboard/TolidTrendPage')));
export const TolidTafkikPage = Loadable(lazy(() => import('../pages/dashboard/TolidTafkikPage')));

// Product
export const ProductPage = Loadable(lazy(() => import('../pages/dashboard/ProductPage')));
export const ProductRptPage = Loadable(lazy(() => import('../pages/dashboard/ProductRptPage')));
export const ProductDPage = Loadable(lazy(() => import('../pages/dashboard/ProductDPage')));
export const DeadstockProductsPage = Loadable(lazy(() => import('../pages/dashboard/DeadstockProductsPage')));

// Dashboard: Report
export const GlucAllPage = Loadable(lazy(() => import('../pages/dashboard/GlucAllPage')));

// Dashboard: HR
export const HRRptPage = Loadable(lazy(() => import('../pages/dashboard/HRRptPage')));
export const HRProfilePage = Loadable(lazy(() => import('../pages/dashboard/HRProfilePage')));

// Dashboard: BaseD
export const ProductListPage = Loadable(lazy(() => import('../pages/dashboard/ProductListPage')));
